import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  
  constructor() {
    this.ensureMaterialIconsLoaded();
  }

  private ensureMaterialIconsLoaded(): void {
    // Check if Material Icons font is loaded
    if (!this.isMaterialIconsLoaded()) {
      this.loadMaterialIcons();
    }
  }

  private isMaterialIconsLoaded(): boolean {
    // Create a test element to check if the font is loaded
    const testElement = document.createElement('span');
    testElement.className = 'material-icons';
    testElement.style.visibility = 'hidden';
    testElement.style.position = 'absolute';
    testElement.textContent = 'home';
    document.body.appendChild(testElement);
    
    const isLoaded = testElement.offsetWidth > 0;
    document.body.removeChild(testElement);
    
    return isLoaded;
  }

  private loadMaterialIcons(): void {
    // Add the Material Icons font link if it doesn't exist
    if (!document.querySelector('link[href*="Material+Icons"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    }
  }
}
